/**
 * Gets an array with the given [from, to] numbers, those included.
 */
const getNumberArray = (from, to) =>
	Array(to - from + 1)
		.fill(0)
		.map(() => from++);
const toPageObject = isCurrentFunction => page => ({
	type: "page",
	page,
	active: isCurrentFunction(page),
});

/**
 * Creates a pagination generator with the given parameters:
 *
 *     @param {number} ellipsisThreshold: how many pages should not be replaced by the ellipsis.
 *
 *     @param {number} padding: how many pages around the active one
 *     should be added
 *
 * The created generator then takes two parameters:
 *
 *     @param {number} current: the currently active page
 *     @param {number} total: total amount of pages
 */
export const createGenerator =
	(ellipsisThreshold, padding) => (current, total) => {
		const firstPage = 1;
		const smallestNearCurrent = Math.max(current - padding, firstPage);
		const biggestNearCurrent = Math.min(current + padding, total);
		const leftEllipsis =
			Math.abs(firstPage - smallestNearCurrent) - 1 > ellipsisThreshold;
		const rightEllipsis =
			Math.abs(total - biggestNearCurrent) - 1 > ellipsisThreshold;

		return [
			...(leftEllipsis
				? [
						{ type: "page", page: firstPage, active: false },
						{ type: "ellipsis" },
					]
				: getNumberArray(firstPage, smallestNearCurrent - 1).map(
						toPageObject(() => false),
					)),
			...getNumberArray(smallestNearCurrent, biggestNearCurrent).map(
				toPageObject(page => page === current),
			),
			...(rightEllipsis
				? [{ type: "ellipsis" }, { type: "page", page: total, active: false }]
				: getNumberArray(biggestNearCurrent + 1, total).map(
						toPageObject(() => false),
					)),
		];
	};

// Parameters are: (see above for description)
// - ellipsisThreshold
// - padding
export const PARAMS_MOBILE = [1, 0];
export const PARAMS_DESKTOP = [1, 1];
